import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--modal"
export default class extends Controller {
  static targets = ["container"]

  connect() {
    // Close on escape key
    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
    this.unlockScroll()
  }

  open(event) {
    event?.preventDefault()
    this.containerTarget.classList.remove("hidden")
    this.lockScroll()
    
    // Focus first focusable element
    requestAnimationFrame(() => {
      const focusable = this.containerTarget.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      focusable?.focus()
    })
  }

  close(event) {
    event?.preventDefault()
    this.containerTarget.classList.add("hidden")
    this.unlockScroll()
  }

  toggle(event) {
    if (this.containerTarget.classList.contains("hidden")) {
      this.open(event)
    } else {
      this.close(event)
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape" && !this.containerTarget.classList.contains("hidden")) {
      this.close(event)
    }
  }

  lockScroll() {
    document.body.style.overflow = "hidden"
  }

  unlockScroll() {
    document.body.style.overflow = ""
  }

  // Close when clicking outside modal content (on backdrop)
  // This is handled via data-action="click->ui--modal#close" on the backdrop element
}
